export enum CustomerInOutpatientIndicatorTypeModel {
	InpatientOnly = 1,
	InpatientAndOutpatient = 2
}
